<template>
  <div>
    <validation-observer :ref="`${code}-validator`">
      <SectionTitle
        class="title-with-space"
        content="VII. Plan de Seguimiento y Consideraciones Adicionales"
        :has-line="true"
      />
      <div class="additional-text">
        <br />
        <p>
          Una vez se recibe el informe de evaluación en Asistencia Tecnológica
          debe de revisarse el PEI conforme a las determinaciones y acuerdos del
          Comité de Programación y Ubicación escolar (COMPU), en todas las
          partes correspondientes. La implantación de los equipos se realiza una
          vez se cuente con los equipos de AT bajo las diversas modalidades para
          proveer los equipos. La determinación de que un equipo de AT provisto
          por el DE sea utilizado en el hogar o en algún servicio relacionado de
          terapia, es una decisión individualizada discutida y avalada en
          reunión de COMPU para que el estudiante reciba una educación apropiada
          y pueda progresar hacia el logro de sus metas educativas . La decisión
          debe documentarse en Minuta de reunión justificando porqué el COMPU
          llega a esta determinación. En esta determinación el COMPU deberá
          considerar que no necesariamente se proveen equipos exclusivamente
          para uso en el hogar.
        </p>
        <p></p>
        <p>
          Los equipos y materiales que se adquieren por medio de la evaluación
          de asistencia tecnológica son para ser utilizados por el estudiante,
          pero PERTENECEN AL DEPARTAMENTO DE EDUCACIÓN. En algunos casos estos
          equipos pueden ser compartidos con otros estudiantes.
        </p>
        <p></p>
        <p>
          El maestro de educación especial o director escolar, deberán ser
          partícipes obligatorios en las discusión en COMPU de la evaluación en
          AT con los padres y cumplimentar la Minuta de Discusión de Evaluación
          de Asistencia Tecnológica, aceptando o rechazando las recomendaciones,
          y a su vez estableciendo a base de las determinaciones del COMPU los
          equipos y servicios para los cuales el COMPU escolar determina someter
          la petición para que se provea la AT. Esta Minuta ha de cumplimentarse
          no más tarde de diez (10) días laborables de recibirse el informe de
          evaluación y ha de ser enviada al CAAT que realizó o canalizó el
          proceso evaluativo, aún cuando se determinara no procesar compra de
          equipos. Cuando se va a solicitar compra o alquiler de equipos es
          necesario a su vez, completar y enviar al CAAT conjunto a la minuta
          indicada, el formulario Solicitud de Equipos y/o Servicios de
          Asistencia Tecnológica. Cuando se va a solicitar compra de equipos
          estos dos documentos han de ser enviados al CSEE conjunto a copia de
          la evaluación en Asistencia Tecnológica que recomienda los equipos, o
          conjunto al aval del CAAT sobre consulta, petición, o evaluación
          privada realizada.
        </p>
        <p>
          Al solicitar la compra de equipos de AT debe considerarse la petición
          de adiestramiento para aquellos que así lo requieran, si el personal
          escolar desconoce sobre el uso del mismo. (Tome en cuenta que hay
          equipos que no requieren de adiestramiento.)
        </p>
        <p></p>
        <p>
          El estudiante, sus padres, maestros y profesionales que trabajan con
          el estudiante, deben ser adiestrados en el manejo técnico de los
          equipos y programas recomendados. Según establece la Ley 402 del 9 de
          septiembre 2000, el mismo debe ser provisto por el suplidor del
          equipo.
        </p>
      </div>
      <div class="additional-text">
        <h2 class="sub-title">
          Ley 402 - Artículo 5: Instalación y Adiestramiento:
        </h2>
        <p>
          “A fin de que el consumidor de un equipo de asistencia tecnológica
          conozca y saque mayor provecho a éste, el manufacturero, suplidor,
          distribuidor, vendedor autorizado o arrendador autorizado, según sea
          el caso, proveerá al consumidor, directamente o a través de un experto
          en la materia, la instalación del equipo y adiestramiento sobre el uso
          y manejo del mismo”.
        </p>
        <p></p>
        <p>
          Este adiestramiento es uno básico, el cual no necesariamente llena
          todas las necesidades del usuario en relación al mejor uso del equipo
          de asistencia tecnológica y su integración a los distintos ambientes
          en los que participa el estudiante. Por lo tanto, si se entiende que
          existe la necesidad de recibir sesiones de adiestramiento adicionales,
          debe entonces solicitarlas como parte de los servicios de asistencia
          tecnológica. Este Los adiestramientos no se limitan solo a la persona
          con impedimentos que utilizará el equipo, puede incluir a la maestra,
          los padres y cualquier otra persona significativa en la i
          implementación de los equipos....
        </p>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle'
import TABS from '@/utils/constants/evaluationTabs'
export default {
  name: 'Tab-VII',
  components: {
    SectionTitle,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    code: {
      type: String,
      default: () => '',
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  computed: {},
  async mounted() {
    await this.initData()
  },
  methods: {
    async initData() {
      this.$emit('loaded', TABS.VII)
    },
    async validate() {
      const valid = await this.$refs[`${this.code}-validator`].validate()
      return {
        valid,
        message: valid ? '' : 'error message',
      }
    },
    async save() {},
  },
}
</script>

<style lang="scss">
.title-with-space {
  margin-top: 20px; /* Adjust the value as per your requirement */
}

.sub-title {
  font-weight: bold;
  font-size: 1em; /* Adjust the size as per your preference */
}
</style>
